/**
 * DMU — indgangspunkt.
 * Vite bundler denne fil og alle importerede moduler + stylesheets.
 */

import './styles/main.css';

import { mountLogos }     from './js/core/logo.js';
import { mountOrnaments } from './js/core/ornament.js';
import { initNavigation } from './js/navigation.js';
import { initReveal }     from './js/reveal.js';
import { initGenerations } from './js/generations/index.js';
import { initAccordionTools } from './js/accordion.js';
import { initYearsSince } from './js/yearsSince.js';

function boot() {
  mountLogos();
  mountOrnaments();
  initNavigation();
  initReveal();
  initGenerations();
  initAccordionTools();
  initYearsSince();
}

document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', boot)
  : boot();
